import { useCallback } from 'react';
import { useAuthenticatedApiContext } from '../api/useApiClient';
import { AsyncState, useAsync } from './useAsync';
import { useAsyncEffect } from './useAsyncEffect';
import { MetricHistory } from '../types';

interface MetricHistoryResult {
  metricHistory: MetricHistory | undefined;
  loadMetricHistory: AsyncState<MetricHistory, () => Promise<MetricHistory>>;
}

export const useMetricHistory = (days: number, metricType: string): MetricHistoryResult => {
  const apiClient = useAuthenticatedApiContext();

  const loadMetricHistory = useAsync(
    useCallback(
      () => apiClient.getMetricHistory(days, metricType),
      [apiClient, days, metricType]
    )
  );

  useAsyncEffect(loadMetricHistory, [days, metricType]);

  return {
    metricHistory: loadMetricHistory.value,
    loadMetricHistory,
  };
};
